//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// custom pages
import Logo from "assets/img/consent-logo.png";
import ContentImage from "assets/img/21DS1776-Thrive Current Vs Future.jpg";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";

export default function ManualTransferApproval() {
  const { getManualTransferStatus, manualTransfer, cancelManualTransfer } =
    auth();
  const classes = consentStyles();
  const location = useLocation();

  const param = new URLSearchParams(location.search);
  const token = param.get("token");

  const [billingAccount, setBillingAccount] = useState({});
  const [loading, setLoading] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [usLink, setusLink] = useState("");

  useEffect(() => {
    handleGetStatus();
  }, []);

  const handleGetStatus = async () => {
    try {
      setLoading(true);
      let res = await getManualTransferStatus(token);
      if (res && res?.type == "success") {
        if (res?.redirectionURL) {
          setRedirectUrl(res?.redirectionURL);
        }
        setMessage(res?.message);
        setStatus(res?.status);
        setusLink(res?.usLink)
        setBillingAccount(res.billingAccount);
        setLoading(false);
        return;
      }
      setStatus("Unauthorized");
      setLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  const handleTransfer = async () => {
    try {
      let values = {
        token: token,
      };
      let res = await manualTransfer(values);
      if (res && res?.type == "success") {
        setMessage(res?.message);
        setBillingAccount(res.billingAccount);
        setRedirectUrl(res?.redirectionURL);
        setStatus("Processed");
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleCancel = async () => {
    try {
      let values = {
        token: token,
      };
      let res = await cancelManualTransfer(values);
      if (res && res?.type == "success") {
        let redirectionUrl;
        let referrerUrl = res?.referrerUrl;
        if (referrerUrl.includes("?")) {
          redirectionUrl = `${res?.referrerUrl}&shipto=${res?.encrypted}`;
        } else {
          redirectionUrl = `${res?.referrerUrl}?shipto=${res?.encrypted}`;
        }
        window.location.replace(redirectionUrl);
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <div className={classes.mainDiv}>
      <img src={Logo} style={{ marginTop: 50, marginBottom: 50 }} alt="logo" />
      <Loader Loading={loading}>
        {status === "Inprocessed" && (
          <Card className={classes.card}>
            <div className={classes.divText}>Acknowledgement</div>
            <div className={classes.divSubText}>
              Thrive Rewards is a discount program intended for private dental
              practice and small group practices. For questions regarding
              eligibility, please contact Thrive Rewards Customer Service at
              1-800-888-6684. By enrolling in Henry Schein Thrive Rewards, you
              have read, understood and agree to the{" "}
              <a
                target="_blank"
                href={usLink}
              >
                [Terms & Conditions]
              </a>{" "}
              of this program and acknowledge that your points will be
              transferred from Connection Awards to Thrive Rewards at the
              standard point value. For an overview of the Henry Schein Thrive
              Rewards program rules, point value, and benefits.{" "}
              <a
                target="_blank"
                href={usLink}
              >
                click here
              </a>
            </div>
            <Button
              className={classes.cancelBtn}
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel Transfer
            </Button>
            <Button
              className={classes.enrollBtn}
              onClick={() => {
                handleTransfer();
              }}
            >
              Transfer
            </Button>
          </Card>
        )}

        {status === "Processed" && (
          <div>
            <div className={classes.manualMessage}>
              Thank you for your interest in the Henry Schein Thrive Rewards
              program for your billing account&nbsp;
              <b>
                {billingAccount &&
                  Object.keys(billingAccount).length > 0 &&
                  billingAccount.customer_billto_account_number}
              </b>
              . <br />
              Your request has been submitted successfully and is currently
              pending review. Upon review you will receive an email notification
              regarding your transfer status. For assistance, please contact
              your account manager or call our Thrive Rewards Customer Service
              at 1-800-888-6684 (8AM - 8PM EST Monday-Friday).
            </div>
            <Button
              className={classes.goBackBtn}
              onClick={() => {
                window.location.replace(redirectUrl);
              }}
            >
              Go Back
            </Button>
          </div>
        )}
        {status === "Unauthorized" && (
          <div>
            <div className={classes.message}>{"Unauthorized"}</div>
          </div>
        )}
      </Loader>
      {status === "Inprocessed" && (
        <img
          src={ContentImage}
          alt=""
          style={{ marginBottom: 20 }}
          width="75%"
        />
      )}
    </div>
  );
}
